import {
  collectPanelBreadcrumbAncestors,
  elementPanelLabel,
  sectionPanelLabel,
} from "../../../utils/panelNavigationUtils";

const ownLabel = (object_type, object) => {
  switch (object_type) {
    case "steps":
      return `Step ${object.position}`;
    case "sections":
      return sectionPanelLabel(object);
    case "section_columns":
      return `Column ${object.position || object.id}`;
    case "elements":
      return elementPanelLabel(object);
    case "fields":
      return "Question";
    default:
      return "";
  }
};

// keep breadcrumbs to one row: drop higher-order crumbs, keeping the ones
// closest to the selected object (full label stays in the title tooltip)
export const shortBreadcrumb = (label) => {
  if (!label) return label;
  const parts = label.split(" › ");
  return parts.length > 2 ? `… › ${parts.slice(-2).join(" › ")}` : label;
};

// Builds a breadcrumb label like "Step 1 › Section › Headline" for the
// builder object the AI chat is focused on. Returns null when the object no
// longer exists (e.g. it was deleted since being selected).
export default function aiFocusBreadcrumb(contextData, builder, focus) {
  if (!focus || !focus.object_type || !focus.object_id) return null;

  const variant = contextData.objects.variant;
  const object = (variant[focus.object_type] || {})[focus.object_id];
  if (!object || object.toBeDeleted === true) return null;

  const crumbs = collectPanelBreadcrumbAncestors(
    variant,
    builder.get_object_parent_layer,
    focus.object_type,
    focus.object_id
  );

  const labels = crumbs
    .filter((crumb) => !crumb.columnNumber)
    .map((crumb) => crumb.label);
  labels.push(ownLabel(focus.object_type, object));

  return labels.filter(Boolean).join(" › ") || null;
}
